import { useState, useEffect } from "react";
import { LoadingState } from "./loading";
import {
  ConsumerLoanApplicationApi,
  GetApplicationStatusAndQuoteResponse,
} from "../lib-api";
import { ApiConfiguration } from "../utils/api";

export function useStatusAndQuote(applicationId: string | null) {
  const [statusAndQuote, setStatusAndQuote] =
    useState<GetApplicationStatusAndQuoteResponse>();
  const [loadingState, setLoadingState] = useState<LoadingState>(
    LoadingState.None
  );
  const api = new ConsumerLoanApplicationApi(ApiConfiguration);

  const load = async () => {
    try {
      setLoadingState(LoadingState.Loading);
      const resp = await api.getApplicationStatusAndQuote({
        applicationId: applicationId!,
      });
      setStatusAndQuote(resp);
      setLoadingState(LoadingState.Success);
    } catch (e) {
      setLoadingState(LoadingState.Error);
    }
  };

  const quoteDecision = async (applicationId: string, accept: boolean) => {
    await api.quoteDecision({ body: { applicationId, accept } });
    await load();
  };

  useEffect(() => {
    if (applicationId !== null) {
      load();
    }
  }, []);

  return {
    statusAndQuote,
    loadingState,
    quoteDecision,
  };
}
